import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class SelectionService {
	constructor(private http: HttpClient) { }

	get(id: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.selection:get',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	export(_id: string,_format:string='PDF', _options: any={}): Observable<JSONRpcResponse> {
	      let json={
	          jsonrpc : "2.0",
	          method:"webservice.selection:export",
	         
	  		params: {
	  		  id: _id,
	  		  options :_options
	          }
	      }
	  	if(_format)
	        json.params.options.format = _format;
	     
	  	let rpcMethod = new JSONRpc(json)	
	  	
	    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
	}

}
